
const UploadFile_KEYS = {
    Ticket : "HD",
    Account_setting:"AS",
    Award:"AW",
    Badges:"BD",
    App_link:"AL",
    Announcement:"AN",
    Feed:"FD",
    Article:"AR",
    Album:"GA",
    Message:"MS",
    User_profile:"UP",
    Certificate:"UC",
    New_assessment:"PA",
    Policy:"PL",
    AccountSetting:'AS',
    OrgAwardSetting:'OA',
    OrgBadgesSetting:'OB',
    EmployeeProfile:'PI',
    Assessment:'AC',
    Document: 'DO',
    Assets: 'AS',
    Project: 'PR'
}
export default UploadFile_KEYS;